var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Application',[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_c('b-row',[_c('b-col',[_c('ClientProfile',{attrs:{"mode":"CREATE"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }